<template>
  <div>
    <b-button pill class="navLogin mt-1" @click="signinModal = true">{{$t("message.login")}}</b-button>
    <b-modal v-model="signinModal " hide-footer hide-header size="sm"  modal-class="session-modal">
      <template v-slot:default="{ hide }" >
        <div class="row ">
          <div class="col-2 px-0"></div>
          <div class="col-7 pr-0 pl-1 ml-2">
            <p class="text-center mt-3 mb-0"><b>Log in</b></p>
          </div>
          <div class="col-1 px-0">
            <button class="btn btn-md " @click="hide()"><h3>×</h3></button>
          </div>
        </div>

        <div class="row pt-3">
          <div class="col-12 text-center px-0">
            <b-button @click="authFacebook" class='py-0 px-1' variant="light">
              <b-img v-bind="{ width: 55, height:55}" rounded="0" src="../../../assets/top/PC_mobile/icon/facebook-icon.png"></b-img>
            </b-button>
            <b-button @click="authGoogle" class='py-0 px-1' variant="light">
              <b-img v-bind="{ width: 55, height:55}" rounded="0" src="../../../assets/top/PC_mobile/icon/google-icon.png"></b-img>
            </b-button>
            <b-button @click="signIn('LINE')" class='py-0 px-1' variant="light">
              <b-img v-bind="{ width: 55, height:55}" rounded="0" src="../../../assets/top/PC_mobile/icon/line-icon.png"></b-img>
            </b-button>
          </div>
        </div>

        <div class="row pt-2">
          <div class="col-12 text-center">
            or
          </div>
        </div>

        <validation-observer class="form bg-white" ref="obs" >
          <div class="row mx-2">
            <div class="col-12 mx-auto px-20">
              <validation-provider name="email" rules="required">
                <div slot-scope="mail_adress">
                  <b-input-group class="mt-2 session-input" :class='{"error-input": mail_adress.failed}'>
                    <template #prepend>
                      <b-input-group-text class='session-icon-input'><b-icon icon="envelope-fill"></b-icon></b-input-group-text>
                    </template>
                    <b-form-input placeholder="Email" v-model="email"></b-form-input>
                  </b-input-group>
                  <p v-if="mail_adress.failed" class="error">{{ mail_adress.errors[0] }}</p>
                </div>
              </validation-provider>
            </div>
          </div>

          <div class="row mx-2 mt-2">
            <div class="col-12 mx-auto px-20">
              <validation-provider name="password" >
                <div>
                  <b-input-group class=" session-input-side" :class='{"error-input": isMiss}'>
                    <template #prepend>
                      <b-input-group-text class='session-icon-input'><b-icon icon="lock-fill"></b-icon></b-input-group-text>
                    </template>
                    <b-form-input :type="inputType" placeholder="Password" v-model="password"></b-form-input>
                    <template #append>
                      <b-input-group-text class='session-icon-input-append'><b-icon :icon="icon" @click="switchPassword"></b-icon></b-input-group-text>
                    </template>
                  </b-input-group>
                </div>
              </validation-provider>
              <p class="text-center mt-3 mb-0 text-error" v-if='isMiss'><b>{{$t("message.missPassword")}}</b></p>
            </div>
          </div>
        </validation-observer>

        <div class="row pt-1">
          <div class="col-1 px-0"></div>
          <div class="col-11 mx-auto pl-3">
            <b-button  class="forgot px-0" @click="showForgotPassword">
              <u>{{$t("message.forgot_password")}}</u>
            </b-button>
          </div>
        </div>

        <div class="row pt-3">
          <div class="col-1 px-0"></div>
          <div class="col-10 text-center">
            <b-button  class="login py-2 px-4 width100" @click="login" > {{$t("message.login")}} </b-button>
          </div>
        </div>

        <div class="row pt-2">
          <div class="col-12 text-center">
            or
          </div>
        </div>

        <div class="row pt-2">
          <div class="col-12 text-center">
            <p class="font13 mb-0">※{{$t("message.until_not_account")}}</p>
            <b-button  class="sign_up" @click="signup" >
              {{$t("message.sign_up")}}
            </b-button>
            <br>

            <router-link to="organization">
              <b-button  class="sign_up" @click='signinModal = true'>
                {{$t("message.click_here_businesses")}}
              </b-button>
            </router-link><br>
            <router-link to="agency">
              <b-button  class="sign_up" >
                {{$t("message.click_here_agency")}}
              </b-button>
            </router-link>

          </div>
        </div>
      </template>

    </b-modal>
    <confirm-modal ref="confirmModal" :email="email"></confirm-modal>
    <forgot-password-modal ref="forgotModal"></forgot-password-modal>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver} from "vee-validate";
import ConfirmModal from "@/components/User/Session/ConfirmModal";
import ForgotPasswordModal from "@/components/User/Session/ForgotPasswordModal";
import axios from 'axios';
import { Auth } from "aws-amplify";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    ConfirmModal,
    ForgotPasswordModal
  },
  data() {
    return {
      signinModal: false,
      isChecked: true,
      inputType: 'password',
      email: "",
      password: "",
      icon: "eye-fill",
      isMiss: false
    }
  },
  methods: {
    switchPassword(){
      if (this.isChecked) {
        this.isChecked = false
        this.inputType = "text"
        this.icon = "eye-slash-fill"
      } else {
        this.isChecked = true
        this.inputType = "password"
        this.icon = "eye-fill"
      }
    },
    showForgotPassword(){
      this.$refs.forgotModal.showModal()
    },
    closeModal(){
      this.signinModal = false
    },
    async signIn(provider) {
      //this.$store.dispatch("loading", true); //処理中表示（処理開始）
      Auth.federatedSignIn({ provider });
    },
    signup(){
      this.$emit('showSignup')
      this.signinModal = false
    },
    showModal(){
      this.signinModal = true
    },
    authGoogle(){
      Auth.federatedSignIn({provider: 'Google'})
    },
    authFacebook(){
      Auth.federatedSignIn({provider: 'Facebook'})
    },
    showConfirm(){
      this.$refs.confirmModal.showModal()
    },
    login(){
      this.$refs.obs.validate().then(value =>{
        if(value){
          Auth.signIn(this.email, this.password)
            .then(response =>{
              this.$store.commit('user/setUserOuth', response)
              axios
              .get(process.env.VUE_APP_API + "/users/callback", {headers: {'Authorization': 'Bearer ' + response.signInUserSession.accessToken.jwtToken}})
              .then(result => {
                this.closeModal()
                this.$store.commit('user/setUser', result.data)
                this.$store.commit('user/setEmail', this.email)
                if(result.data.first_name != null){
                  this.$router.replace('/mypage')
                }else{
                  this.$router.replace('/createuser')
                }
              }).catch(error => {
                console.log('this is error', error)
              })
            })
            .catch(error =>{
              console.log(error)
              if(error.code == "UserNotConfirmedException"){
                var locate = this.$i18n.locale
                this.$swal.fire({
                  icon: 'error',
                  title: this.$i18n.messages[locate]['message']["not_confirm"],
                  text: this.$i18n.messages[locate]['message']["move_confirm"] ,
                  confirmButtonText: this.$i18n.messages[locate]['message']['resendCode']
                }).then(()=>{
                  Auth.resendSignUp(this.email)
                    .then(() =>{
                      this.showConfirm()
                    }).catch(error => {
                      console.log('this is error', error)
                    })
                })
              }else{
                if(error.code == 'UserNotFoundException' || error.code == "NotAuthorizedException"){
                  this.isMiss = true
                }

              }
            })

        }
      })
    },
  },
}
</script>
<style scoped lang="scss">
.btn{
  padding: .235rem .75rem;
}
@media (max-width: 768px) {
  .navbar-nav {
    -webkit-box-orient: horizontal !important;
    display: -webkit-box;
  }
}

.modal-header{
  border-bottom: 0px solid #dee2e6;
  text-size: 16px;
  text-align: center!important;
}

.facebook{
  background: #1877F2 !important;
  color: #FFFFFF;
  font-size: 14px;
  width: 90%
}
.line {
  border-color: #00B302 !important;
  background: #00B302 !important;
  color: #FFFFFF;
  font-size: 14px;
  width: 90%
}

.sign_up{
  background: #FFFFFF !important;
  color: #F29147 !important;
  border-color: #FFFFFF !important;

  &:hover {
    box-shadow: none !important;
  }
}

.forgot{
  background: #FFFFFF !important;
  color: #F29147 !important;
  border-color: #FFFFFF !important;
  font-size: 0.7rem;

  &:hover {
    box-shadow: none !important;
  }
}
.mt-2 {
  margin-top: 1rem !important;
}

</style>
